import React, { useRef } from 'react'
import './DragDrop.scss'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { randomString } from '../../../utils/sharedFunctions'
import { uploadImage } from '../../../utils/sharedAttachmentFunctions'

export default function DragDrop({ setFiles, visibleDocument }) {
  const selectedProvider = useSelector((state) => state.user?.provider)
  const fileInput = useRef(null)

  const uploadFiles = (file) => {
    const reader = new FileReader()
    let fileExt = file?.name?.split('.')?.pop()
    let fileName =
      selectedProvider?._id + '_' + new Date().getTime() + randomString(6) + '.' + fileExt

    reader.readAsDataURL(file)
    reader.onloadend = async (e) => {
      let fileData = {
        key: fileName,
        size: file.size,
        file_type: fileExt,
        checksum: null,
        file: file,
        status: 'selected',
        originalFileName: file?.name,
      }

      setFiles((oldFiles) => [...oldFiles, fileData])
    }
  }

  const handleOnDragOver = (e) => {
    e.preventDefault()
  }

  const handleOnDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    let file = e.dataTransfer?.files[0]

    if (visibleDocument) {
      uploadFiles(file)
    } else {
      uploadImage({
        file,
        selectedProvider,
        onSuccess: setFiles,
      })
    }
  }

  return (
    <div className="upload-container" onDragOver={handleOnDragOver} onDrop={handleOnDrop}>
      <>
        {/*TODO- set up to do mass file drops*/}
        <div className="inner-container-one">Drag & Drop your file here</div>
        <div className="inner-container-two">OR</div>
        <div className="inner-container-three">
          <input
            accept="*"
            type="file"
            ref={fileInput}
            onChange={(e) => {
              visibleDocument
                ? uploadFiles(e.target?.files[0])
                : uploadImage({
                    file: e.target?.files[0],
                    selectedProvider,
                    onSuccess: setFiles,
                  })
            }}
            hidden
            id="input-file"
            onClick={(event) => {
              event.target.value = null
            }}
          />
          <div className="browse-files" onClick={() => fileInput.current?.click()}>
            Browse Files
          </div>
        </div>
      </>
    </div>
  )
}

DragDrop.propTypes = {
  setFiles: PropTypes.func,
  visibleDocument: PropTypes.bool,
}
